import { styled } from '@/src/stitches.config'
import Link from 'next/link'
import { CheckboxInputWithChildren } from '@/src/common/components/elements/Forms/CheckboxInputWithChildren'
import { TCheckboxStyleOptions } from '@/src/common/components/elements/Forms/types'
import { ValidationError } from 'yup'
import { FormErrorDisplay } from '@/src/modules/build-a-card/FormErrorDisplay'

const StyledText = styled('p', {
    fontSize: '.85rem',
    width: 255,
    lh: 1.5,
    my: 10,
    a: {
        color: '$primary',
        textDecoration: 'underline',
    },
})

type TTermsProps = TCheckboxStyleOptions & {
    setHasAgreedToTerms: Function
    submissionErrors: ValidationError[]
}

const TermsAndPrivacyAgreement = ({
    setHasAgreedToTerms,
    checkboxSize,
    checkboxVariant,
    submissionErrors,
}: TTermsProps) => {
    return (
        <>
            <CheckboxInputWithChildren
                id={'terms-cb'}
                checkboxVariant={checkboxVariant}
                checkboxSize={checkboxSize}
                setCheckState={setHasAgreedToTerms}
            >
                <StyledText>
                    I agree to BuyGiftCards.com&#39;s{' '}
                    <Link href={'/terms-of-use'} target="_blank">
                        Terms of Use
                    </Link>{' '}
                    and{' '}
                    <Link href={'/privacy-policy'} target="_blank">
                        Privacy Policy
                    </Link>
                    .
                </StyledText>
            </CheckboxInputWithChildren>
            <FormErrorDisplay
                formErrors={submissionErrors}
                path={'agreedToTerms'}
            />
        </>
    )
}

export default TermsAndPrivacyAgreement
